import ForwardableCv from "./ForwardableCv";

export { ForwardableCv as default };
